import { Header } from "@/components";
import Footer from "../../components/common/layout/Footer";
import JobDetail from "@/components/detail/JobDetailPage";

export default function JobDetailPage() {
    return(
        <div>
            <Header />
            <JobDetail />
            <Footer />
        </div>
    )
}